import { useLs } from '@/setup/vueLs';
import type { UiTableNewFieldBase } from '@/types/table';
import type { ComponentPublicInstance, MaybeRefOrGetter } from 'vue';

const checkColunmWidth = function checkColunmWidth(fields: any[], keyLocal: string, tableFieldsExMethods: UiTableNewFieldBase[]) {
  const ls = useLs();
  const localFiels: any[] = ls.get(keyLocal);

  if (localFiels) {
    const mergeField = fields.map((elem) => {
      const indexLocalFields = localFiels.findIndex((e) => e.name === elem.name) || null;
      return { ...elem, ...localFiels[indexLocalFields!] };
    });
    return mergeField;
  }
  ls.remove(keyLocal);
  ls.set(keyLocal, tableFieldsExMethods);
  return undefined;
};

const setColumnWidth = function setColumnWidth(column: any, fields: any[], keyLocal: string, deltaWidth: number, CUSTOM?: string) {
  const { property, width, minWidth/* , realWidth  */ } = column;
  const ls = useLs();

  if (property === undefined) return undefined;
  let findIndexColumnFlex = 0;
  if (deltaWidth > 0) {
    findIndexColumnFlex = fields.findIndex((item) => item.flexible && item.name !== property);

    if (findIndexColumnFlex === -1) {
      findIndexColumnFlex = fields.findIndex((item) => item.flexible);
    }
    if (findIndexColumnFlex === -1 && CUSTOM === 'customReport') {
      findIndexColumnFlex = 0/* fields.findIndex(item => item.flexible) */;
    }
  }


  let findIndexColumn = 0;
  const changeObj = fields.find((item, index) => {
    findIndexColumn = index;
    return property === item.name;
  });

  changeObj.width = width <= minWidth ? minWidth : width;

  const localFiels = ls.get(keyLocal);
  localFiels[findIndexColumn] = {
    name: property,
    width: changeObj.width,
    forceUpdateKey: CUSTOM === 'customReport' ? +new Date() : undefined,
  };

  if (deltaWidth > 0) delete localFiels[findIndexColumnFlex].width;

  ls.set(keyLocal, localFiels);
  return {
    newData: [findIndexColumn, changeObj],
    // setMinWidth,
  };
};

//TODO: типизировать согласно таблице
const getDeltaWidth = function getDeltaWidth(refDataTable: any) {
  const { offsetWidth: widthContainer } = refDataTable.$el.querySelector('.el-table > .el-table__inner-wrapper > .el-table__header-wrapper');
  const columnsCollection: any[] = refDataTable.datatableRef.columns;

  const columnsCollectionWidth = columnsCollection.reduce((acc, e) => {
    if (e.realWidth) {
      return acc + e.realWidth;
    }
    return acc + e.width;
  }, 0);
  const deltaWidth = widthContainer - columnsCollectionWidth;
  return deltaWidth;
};


export {
  checkColunmWidth,
  setColumnWidth,
  getDeltaWidth,
};
